function syncMobileHeaderHeight() {
  const header = document.querySelector('.site-header');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (!header || !mobileMenu) return;

  const setOffset = () => {
    const height = Math.ceil(header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--mobile-header-height', `${height}px`);
  };

  const onToggle = () => {
    setOffset();
    // Lock body scroll while the panel is open: the header is sticky (shrinks once the
    // announcement bar scrolls past), and the panel's offset is only measured at open time —
    // without a scroll lock, scrolling mid-open would leave a gap between the now-shorter
    // header and the panel still positioned for the taller one. Locking scroll keeps the
    // header exactly as it was when opened, so the panel stays flush the whole time.
    document.documentElement.classList.toggle('mobile-menu-open', mobileMenu.open);
  };

  setOffset();
  window.addEventListener('resize', setOffset);
  // Re-measure on open: the announcement bar (not sticky) may have scrolled out of view by
  // then, or its message may wrap to a second line on a narrow phone, changing the real
  // offset from what it was on page load.
  mobileMenu.addEventListener('toggle', onToggle);
}

syncMobileHeaderHeight();

class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('[data-predictive-search-toggle]');
    this.closeButton = this.querySelector('[data-predictive-search-close]');
    this.panel = this.querySelector('.predictive-search__panel');
    this.input = this.querySelector('[data-predictive-search-input]');
    this.results = this.querySelector('[data-predictive-search-results]');
    this.url = this.dataset.predictiveSearchUrl;

    this.toggleButton.addEventListener('click', () => this.open());
    this.closeButton.addEventListener('click', () => this.close());
    this.input.addEventListener('input', this.debounce(() => this.search(), 300));

    this.onDocumentClick = (event) => {
      if (!this.contains(event.target)) this.close();
    };
    this.onDocumentKeydown = (event) => {
      if (event.key === 'Escape') this.close();
    };
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onDocumentKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onDocumentKeydown);
  }

  open() {
    this.panel.hidden = false;
    this.toggleButton.setAttribute('aria-expanded', 'true');
    this.input.focus();
  }

  close() {
    this.panel.hidden = true;
    this.toggleButton.setAttribute('aria-expanded', 'false');
  }

  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  search() {
    const query = this.input.value.trim();

    if (query.length < 2) {
      this.results.innerHTML = '';
      return;
    }

    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product',
      'resources[limit]': 6,
      'resources[options][unavailable_products]': 'last',
    });

    fetch(`${this.url}.json?${params.toString()}`)
      .then((response) => response.json())
      .then((data) => this.renderResults(data.resources.results.products, query))
      .catch(() => {
        this.results.innerHTML = '';
      });
  }

  renderResults(products, query) {
    if (!products.length) {
      this.results.innerHTML = `<p class="predictive-search__empty">${this.dataset.noResultsText}</p>`;
      return;
    }

    const items = products
      .map(
        (product) => `
          <a href="${product.url}" class="predictive-search__result">
            <span class="predictive-search__result-media">
              ${product.image ? `<img src="${product.image}" alt="" loading="lazy">` : ''}
            </span>
            <span class="predictive-search__result-info">
              <span class="predictive-search__result-title">${product.title}</span>
              <span class="predictive-search__result-price">${product.price}</span>
            </span>
          </a>
        `
      )
      .join('');

    const searchUrl = this.querySelector('.predictive-search__form').getAttribute('action');
    const viewAll = `<a href="${searchUrl}?q=${encodeURIComponent(query)}&type=product" class="predictive-search__view-all">${this.dataset.viewAllText}</a>`;

    this.results.innerHTML = items + viewAll;
  }
}

customElements.define('predictive-search', PredictiveSearch);
